import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles({
  countNumber: {
    textAlign: 'center',
    padding: '0px 5px',
  },
});
